<template>
  <div class="main-content">

    <b-card no-body>
      <b-tabs pills card>
        <b-tab title="Detalhes" active>
          <!-- status badge removed: UI showed inconsistent states. Status should be inferred from assignment/device details. -->
          <div class="row mt-1">
            <div class="col-md-12">
              <VehicleData
          :vehicleData="data" :backBattery="backBattery"
          :mainBatteryDec="mainBatteryDec" :modalShow="showDeviceActivtions"
          :modalConfigShow="showDeviceActivtionsConfigs"
          :activeAssignment="activeAssignment"
          @showDeviceActivations="showModalDeviceActivtions"
          @showDeviceActivationsConfig="showDeviceActivtionsConfig"
          @edit-assignment="openAssignmentEditor"
              />
            </div>
          </div>
          <div class="mt-n4">
            <b-card-group deck>
              <b-card no-body border-variant="warning" @click="showModalRefuleingShow" style="cursor: pointer;">
                <b-card-body class="pb-0">
                  <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                    <feather-icon size="21" :icon="'DollarSignIcon'"/>
                  </b-avatar>
                  <div class="text-right pb-1">

                    <b-badge variant="dark"> {{ licensingExpired ? formattedMoney(refuelingSomValue) : '0' }}
                      {{ $t('Paid out') }}
                    </b-badge>

                  </div>
                  <div class="truncate mb-2">
                    <h2 class="mb-25 font-weight-bolder">
                      {{ getLenghtRefueling }}
                    </h2>
                    <span>{{ $t('Supplies') }} </span>
                  </div>
                </b-card-body>
              </b-card>
              <b-card no-body border-variant="danger" @click="showModalFineShow" style="cursor: pointer;">
                <b-card-body class="pb-0">
                  <b-avatar class="mb-1" :variant="`light-danger`" size="45">
                    <feather-icon size="21" :icon="'FileTextIcon'"/>
                  </b-avatar>
                  <div class="text-right pb-1">

                    <b-badge variant="warning"> {{ data.fine[0] ? data.fine[0].fineType : '' }}</b-badge>

                  </div>
                  <div class="truncate mb-2">
                    <h2 class="mb-25 font-weight-bolder">
                      {{ getLenghtFines }}
                    </h2>
                    <span>{{ $t('Fines') }} </span>
                  </div>
                </b-card-body>
              </b-card>

              <b-card no-body border-variant="success" @click="showModalAutoInsuranceShow" style="cursor: pointer;">
                <b-card-body class="pb-0">
                  <b-avatar class="mb-1" :variant="`light-success`" size="45">
                    <feather-icon size="21" :icon="'ShieldIcon'"/>
                  </b-avatar>
                  <div class="text-right pb-1">

                    <b-badge variant="primary"> {{
                        data.autoInsurance[0] ? data.autoInsurance[0].insurance : ''
                      }}
                    </b-badge>

                  </div>
                  <div class="truncate mb-2">
                    <h2 class="mb-25 font-weight-bolder">
                      {{ getLenghtAutoInsurance }}
                    </h2>
                    <span>{{ $t('Insurance') }} </span>
                  </div>
                </b-card-body>
              </b-card>


              <b-card no-body border-variant="info" @click="showModalLicensingShow" style="cursor: pointer;">
                <b-card-body class="pb-0">
                  <b-avatar class="mb-1" :variant="`light-info`" size="45">
                    <feather-icon size="21" :icon="'CreditCardIcon'"/>
                  </b-avatar>
                  <div v-if="licensingExpired" class="text-right pb-1">

                    <b-badge variant="danger">
                      {{ licensingExpired ? licensingExpired + '  - ' + $t('Expired') : '...' }}
                    </b-badge>
                  </div>
                  <div v-else class="text-right pb-1 ">

                    <b-badge variant="warning">
                      {{ licensingExpired ? '(' + licensingExpired + ') ' + $t('Expiry on') : '...' }}
                    </b-badge>
                  </div>

                  <div class="truncate mb-2">
                    <h2 class="mb-25 font-weight-bolder">
                      {{ getLenghtLicensing }}
                    </h2>
                    <span>{{ $t('Licensing') }} </span>
                  </div>
                </b-card-body>
              </b-card>

            </b-card-group>
          </div>

          <!-- modals  -->
          <div class="row">
            <b-modal v-model="modalFineShow" size="xl" hide-footer>
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">

                    <h3>{{ $t('Fines') }} : {{ getLenghtFines }}</h3>
                    <div class="col-md-12 " v-for="(item, index) in data.fine" :key="index">
                      <fines :props="item"/>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
            <b-modal v-model="modalRefuleingShow" size="xl" hide-footer>
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <h3>{{ $t('Supplies') }}</h3>
                    <div class="col-md-12  " v-for="(item, index) in data.refueling" :key="index">
                      <refueling :props="item"/>

                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
            <b-modal v-model="modalAutoInsuranceShow" size="xl" hide-footer>
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <h3>{{ $t('Insurance') }}</h3>
                    <div class="col-md-12  " v-for="(item, index) in data.autoInsurance" :key="index">
                      <AutoInsurance :props="item"/>
                    </div>
                  </div>

                </div>
              </div>
            </b-modal>
            <b-modal v-model="modalLicensingShow" size="xl" hide-footer>
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <h3>{{ $t('Licensing') }}</h3>
                    <div class="col-md-12  " v-for="(item, index) in data.licensing" :key="index">
                      <Licensing :props="item"/>

                    </div>
                  </div>

                </div>
              </div>
            </b-modal>

            <b-modal v-model="showDeviceActivtions" :title="$t('Devices')" size="lg" hide-footer>
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div v-if="devicesLoading" class="text-center py-3">
                      <i class="fas fa-spinner fa-spin"></i>
                    </div>

                    <div v-else>
                      <div v-if="activeAssignmentDevices && activeAssignmentDevices.length">
                        <b-row>
                          <b-col cols="12" md="6" lg="4" v-for="d in activeAssignmentDevices" :key="d.id || d.device_id" class="mb-2">
                            <div class="border rounded p-2 h-100">
                              <div class="font-weight-bold">{{ extractDeviceInfo(d).imei || '-' }}</div>
                              <div class="text-muted small">{{ extractDeviceInfo(d).description || '-' }}</div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else class="text-muted">
                        {{ $t('There are no devices for this vehicle') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>

            <b-modal v-model="showAssignmentModal" size="lg" :title="$t('Vehicle Assignments')" hide-footer centered backdrop>
              <div class="col-md-12">
                <div class="d-flex justify-content-end mb-2">
                  <b-button size="sm" variant="primary" @click="openChildTransfer">
                    <i class="fas fa-exchange-alt"></i>
                    {{ $t('Assign Vehicle') }}
                  </b-button>
                </div>

                <VehicleAssignmentEditor
                  ref="vehicleAssignmentEditor"
                  v-if="$route.params.id"
                  :vehicleId="$route.params.id"
                  @assignment-changed="onAssignmentChanged"
                />
              </div>

              <template #modal-footer>
                <b-button variant="secondary" @click="showAssignmentModal = false">{{ $t('Close') }}</b-button>
                <b-button variant="primary" @click="($refs.vehicleAssignmentEditor && $refs.vehicleAssignmentEditor.save())">{{ $t('Save') }}</b-button>
              </template>
            </b-modal>
          </div>
        </b-tab>
        <b-tab :title="$t('Maintenances')">
          <div class="col-md-12 text-center mt-n2">
            <h3>Manutenções: {{ getLenghtMaintenances }}</h3>
            <div class="text-right">
              <router-link to="/maintenances/add" class="btn btn-primary">{{
                  $t('Add') + ' ' + $t('New')
                }}
              </router-link>
            </div>
            <div class="col-md-12 " v-for="(item, index) in data.maintenances" :key="index">
              <Maintenances :props="item"/>
            </div>
          </div>

        </b-tab>
        <b-tab :title="$t('Current Position')">
          <div class="col-md-12 text-center mt-n2" v-if="positionVehicle.data">
            <MapPositionNowPoint
                :notificationDate="positionVehicle.data ? convertToLocalTime(positionVehicle.data) : null"
                :vehicleDatalhe="vehicleDatalhe"
                :postionDevice="positionVehicle"
                :centerProp="center"
                :ray="0.2"
                :zoom="20"
                :areaTypeId="1"
                :polygonCoordinates="[]"
                :url="imgUrl"
                @reload="getLastVehiclePosition($route.params.id)"
                :show-button="false"
                :show-text="false"
            />

          </div>

        </b-tab>
        <b-tab :title="$t('Position History')">
          <div class="col-md-12 text-center mt-n2">
            <VehicleTrackingMap
                :url="imgUrl"
                :zoom="13"
                :routeCoordinates="vehiclePositions"
                :vehicleDatalhe="data"
                @reload="reloadData"
                @zoomChanged="onZoomChange"
            />
          </div>

        </b-tab>
      </b-tabs>
    </b-card>

  </div>
</template>

<script>
// eslint-disable-next-line camelcase
import VehicleData from './components/VehicleData'
import VehicleAssignmentEditor from './components/VehicleAssignmentEditor.vue';
import DeviceActivation from './components/DeviceActivation';
import Fines from './components/Fines';
import Refueling from './components/Refueling';
import AutoInsurance from './components/AutoInsurance';
import Licensing from './components/Licensing';
import Maintenances from './components/Maintenances';
import DeviceConfig from './components/DeviceConfig';
import MapPositionNowPoint from '../../layouts/Mapa/MapPositionNowPoint';
import VehicleTrackingMap from '../../layouts/Mapa/VehicleTrackingMap.vue';
import VehicleInfo from "@/layouts/Mapa/VehicleInfo.vue";
import axios from 'axios';
import moment from 'moment';

const LEVEL = {
  0: 'Register',
  1: 'Active',
  2: 'Inactive',
  3: 'Available',
  5: 'Off'
}

const LEVEL_CLASS = {
  0: 'badge bg-primary',
  1: 'badge bg-success',
  2: 'badge badge-secondary',
  3: 'badge badge-warning',
  5: 'badge badge-danger'
}
export default {
  data() {
    return {
      selectedVehicleDetails: {},
      vehicleDatalhe: {},
      modalVehicleInfo: false,
      circleCenter: {lat: 0, lng: 0},
      data: {
        deviceActivation: {},
        fine: [],
        refueling: [],
        autoInsurance: [],
        licensing: [],
        deviceAssignment: [],
      },
      showInfoWindow: null,
      vehiclePositions: [],
      loading: false,
      error: null,
      showDeviceActivtions: false,
      showDeviceActivtionsConfigs: false,
      modalLicensingShow: false,
      modalAutoInsuranceShow: false,
      modalRefuleingShow: false,
      modalFineShow: false,
      devicesLoading: false,
      activeAssignment: null,
      activeAssignmentDevices: [],
      status: [{
        name: this.$t('Free'),
        id: 0,
      }, {
        name: this.$t('Courtyard'),
        id: 1,
      }, {
        name: this.$t('Occurrence'),
        id: 2,
      }, {
        name: this.$t('Under maintenance'),
        id: 3,
      }],
      errors: undefined,
      previewImage: null,
      licensingExpired: 0,
      licensingExpiryOn: 0,
      refuelingSomValue: 0,
      positionVehicle: {
        data: null,
        latitude: null,
        longitude: null,
        velocidade: null,
      },
  showAssignmentModal: false,
      postionDevice: {
        speed: 0,
        imei: '',
        nofixcounter: 1,
        SleepMode: 'ON',
        _id: '',
        lastfixtime: '',
        timestamp: '',
        coord: {lat: '0', lon: '0'},
        lastsampletime: '',
        backBattery: 0,
        MainBatteryDec: 0,
      },
      isLoading: false,
      showMapa: false,
      centerMap: {},
      has_limit: 100,
      has_dataFrist: null,
      has_dataFim: null,
    };
  },
  computed: {
    getLenghtFines() {
      return this.data?.fine?.length ?? 0;
    },
    getLenghtMaintenances() {
      return this.data?.maintenances?.length ?? 0;
    },
    getLenghtRefueling() {
      return this.data?.refueling?.length ?? 0
    },
    getLenghtAutoInsurance() {
      return this.data?.autoInsurance?.length ?? 0;
    },
    getLenghtLicensing() {
      return this.data?.licensing?.length ?? 0;
    },
    consultApi() {
      return this.$store.state.consultApi + this.data.license_plate;
    },
    center() {
      return this.centerMap;
    },
    imgUrl() {
      return this.data.vehicle_image_url;
    },
    backBattery() {
      return this.postionDevice.BackBattery ? Number(this.postionDevice.BackBattery) : 0
    },
    mainBatteryDec() {
      return this.postionDevice.MainBatteryDec ? Number(this.postionDevice.MainBatteryDec) : 0
    },
    imei() {
      return this.data.deviceActivation.imei ?? null
    },
    limit() {
      return this.has_limit ?? 100
    },
    dataFrist() {
      if (this.has_dataFrist) {
        return this.has_dataFrist
      }

      const data_now = new Date()
      const oneHourInMillis = 60 * 60 * 1000;
      const data = new Date(data_now.getTime() - oneHourInMillis);
      return this.formatDateTime(data)
    },
    dataFim() {
      if (this.has_dataFim) {
        return this.has_dataFim
      }
      const data_now = new Date()

      return this.formatDateTime(data_now)
    },
    markerPosition() {
      const coord = this.updateInfo?.coord || {lat: 0, lon: 0};
      return {lat: Number(coord.lat), lng: Number(coord.lon)};
    }
  },
  methods: {
    openVehicleInfo(details) {
      this.selectedVehicleDetails = details || {};
      this.vehicleDatalhe = this.data;
      this.modalVehicleInfo = true;
    },
    formatDeviceLabel(device) {
      if (!device) return '-';
      const node = device.device || device;
      const imei = node.imei || node.serial_number || node.identifier || node.id || node.device_id;
      const desc = node.description || node.name || node.model || node.type;
      if (imei && desc) return `${imei} - ${desc}`;
      if (imei) return String(imei);
      if (desc) return desc;
      return '-';
    },
    extractDeviceInfo(device) {
      const node = device && (device.device || device) || {};
      const imei = node.imei || node.serial_number || node.identifier || node.id || node.device_id || null;
      const description = node.description || node.name || (node.device_model && node.device_model.name) || node.model || node.type || null;
      return { imei, description };
    },
    async fetchActiveAssignmentDevices() {
      try {
        this.devicesLoading = true;
        this.activeAssignment = null;
        this.activeAssignmentDevices = [];
        const vehicleId = this.$route.params.id;

        if (!vehicleId) return;

        const resp = await axios.get(`${this.$store.state.api}vehicles/${vehicleId}/assignments`);
        const payload = resp && resp.data ? resp.data : {};
        const root = payload.data || payload || {};
        let active = root.active_assignment;
        if (!active && Array.isArray(root.assignments)) {
          active = root.assignments.find(a => a && (a.status === 'active' || !a.end_date)) || null;
        }
        this.activeAssignment = active || null;

        let devices = [];
        if (active) {
          if (Array.isArray(active.devices) && active.devices.length) devices = active.devices;
          else if (Array.isArray(active.device_vehicle_assignment) && active.device_vehicle_assignment.length) devices = active.device_vehicle_assignment;
        }
        if (!devices.length) devices = root.devices || [];

        if (!devices.length) {
          try {
            const devResp = await axios.get(`${this.$store.state.api}vehicles/${vehicleId}/devices`);
            const dr = devResp && devResp.data ? devResp.data : [];
            const list = Array.isArray(dr) ? dr : (dr.data || dr.devices || []);
            if (Array.isArray(list) && list.length) devices = list;
          } catch ($e) {
            console.error($e);
           }
        }

        if (!devices.length) {
          const qp = `devices?with[]=activeAssignment.vehicleAssignment.vehicle&limit=1000`;
          try {
            const allDevResp = await axios.get(`${this.$store.state.api}${qp}`);
            const rd = allDevResp && allDevResp.data ? (allDevResp.data.data || allDevResp.data) : [];
            const arr = Array.isArray(rd) ? rd : (rd.data || []);
            const license = this.data.license_plate;
            devices = (arr || []).filter(d => {
              const va = d && d.active_assignment && d.active_assignment.vehicle_assignment;
              const veh = va && (va.vehicle || va.vehicle_id);
              const plate = veh && veh.license_plate ? veh.license_plate : null;
              return plate && license && String(plate).toUpperCase() === String(license).toUpperCase();
            });
          } catch (_) { /* ignore */ }
        }

        this.activeAssignmentDevices = Array.isArray(devices) ? devices : [];
        this.$set(this.data, 'deviceAssignment', this.activeAssignmentDevices);
      } catch (e) {
        this.$error(e);
      } finally {
        this.devicesLoading = false;
      }
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    reloadData(event) {
      this.fetchHistoricData(event.dataFrist, event.dataFim, event.limit)
    },
    onZoomChange(newZoom) {
      console.log('Novo nível de zoom:', newZoom);
    },
    hideModalDetallhes() {
      this.showDeviceActivtions = false
      this.showDeviceActivtionsConfigs = false
      this.modalLicensingShow = false
      this.modalAutoInsuranceShow = false
      this.modalRefuleingShow = false
      this.modalFineShow = false

    },
    async showModalDeviceActivtions() {
      this.hideModalDetallhes()
      await this.fetchActiveAssignmentDevices()
      this.showDeviceActivtions = true
    },
    async openAssignmentEditor() {
      this.hideModalDetallhes();
      await this.fetchActiveAssignmentDevices();
      this.showAssignmentModal = true;
    },
    showDeviceActivtionsConfig() {
      this.hideModalDetallhes()
      this.showDeviceActivtionsConfigs = true
    },
    showModalLicensingShow() {
      this.hideModalDetallhes()
      this.modalLicensingShow = true
    },
    showModalAutoInsuranceShow() {
      this.hideModalDetallhes()
      this.modalAutoInsuranceShow = true
    },
    showModalRefuleingShow() {
      this.hideModalDetallhes()
      this.modalRefuleingShow = true
    },
    showModalFineShow() {
      this.hideModalDetallhes()
      this.modalFineShow = true

    },
    formattedMoney(money) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(money)
    },
    convertToLocalTime(gmtDate) {
      if (!gmtDate) return null;

      if (typeof gmtDate !== "string" || !gmtDate.includes(" ")) return null;

      const [datePart, timePart] = gmtDate.split(" ");
      if (!datePart || !timePart) return null;

      const [day, month, year] = datePart.split("/");
      const [hours, minutes, seconds] = timePart.split(":");
      if (!day || !month || !year || !hours || !minutes || !seconds) return null;

      const gmtDateObject = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`);
      if (isNaN(gmtDateObject.getTime())) return null;

      return `${String(gmtDateObject.getDate()).padStart(2, "0")}/` +
          `${String(gmtDateObject.getMonth() + 1).padStart(2, "0")}/` +
          `${gmtDateObject.getFullYear()} ` +
          `${String(gmtDateObject.getHours()).padStart(2, "0")}:` +
          `${String(gmtDateObject.getMinutes()).padStart(2, "0")}:` +
          `${String(gmtDateObject.getSeconds()).padStart(2, "0")}`;
    },
    getStatusLabel(index) {
      if (this.data && this.data.deviceActivation && this.data.deviceActivation.status === 1) {
        return this.$t(LEVEL[1]);
      }
      if (this.activeAssignment && (this.activeAssignment.status === 'active' || !this.activeAssignment.end_date)) {
        return this.$t(LEVEL[1]);
      }
      return this.$t(LEVEL[index]);
    },
    getStatusClass(index) {
      if (this.data && this.data.deviceActivation && this.data.deviceActivation.status === 1) {
        return LEVEL_CLASS[1];
      }
      if (this.activeAssignment && (this.activeAssignment.status === 'active' || !this.activeAssignment.end_date)) {
        return LEVEL_CLASS[1];
      }
      return LEVEL_CLASS[index];
    },
    getPositionVehicle: function () {
      this.hideModalDetallhes()
      let api = this.$store.state.api + 'vehicles/position/' + this.data.license_plate;

      axios
          .get(api)
          .then((response) => {
            this.positionVehicle = response.data
            this.showMapa = true

            this.centerMap = {
              lat: Number(this.positionVehicle.latitude),
              lng: Number(this.positionVehicle.longitude)
            }
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    getPositionVehicleByImei: function () {
      this.hideModalDetallhes()
      if (!this.data.deviceActivation.imei) {
        return this.getPositionVehicle()
      }

      let api = this.$store.state.api + 'vehicles/imei/' + this.data.deviceActivation.imei;

      axios
          .get(api)
          .then((response) => {
            this.postionDevice = response.data
            const dateFormat = moment(`${this.postionDevice.lastsampletime}`).format('DD/MM/YYYY HH:mm:ss');
            this.positionVehicle = {
              latitude: this.postionDevice.coord.lat,
              longitude: this.postionDevice.coord.lon,
              velocidade: this.postionDevice.speed,
              data: dateFormat,


            }
            this.centerMap = {
              lat: Number(this.postionDevice.coord.lat),
              lng: Number(this.postionDevice.coord.lon)
            }
            this.showMapa = true

          })
          .catch((error) => {
            this.$message('Sem posição informado', '', error);
          });

    },
    processPositionVehicle: function () {
      const {license_plate, deviceActivation} = this.data;
      if (deviceActivation.status !== 1) {
        return;

      }
      const imei = deviceActivation?.imei;
      const supplier = deviceActivation?.supplier === "Movias" ? "Movias" : "claranet";

      const apiUrl = `${this.$store.state.api}vehicles/processar`;
      const postData = {
        license_plate,
        imei,
        supplier,
      };
      axios
          .post(apiUrl, postData, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            console.log("processPositionVehicle:", response.data);
          })
          .catch((error) => {
            console.error('Erro no processPositionVehicle:', error);
          })
          .finally(() => {
            console.log('processPositionVehicle fim');
          });

      setTimeout(() => {
        this.getPositionVehicleByImei();
      }, 3000);
      setTimeout(() => {
        console.log(" start call fetchHistoricData");
        this.fetchHistoricData(this.dataFrist, this.dataFim, this.limit)
      }, 5000);
    },
    async fetchHistoricData(dataFrist, dataFim, limit) {
      console.log("fetchHistoricData inicio");
      this.loading = true;
      this.error = null;
      const apiUrl = `${this.$store.state.api}vehicles/findHistoric`;

      let postData = {
        imei: this.imei,
        dataFrist: dataFrist,
        dataFim: dataFim,
        limit: limit
      }
      console.log('fetchHistoricData postData', postData);
      axios
          .post(apiUrl, postData, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            console.log("fetchHistoricData response:", response.data);
            this.vehiclePositions = response.data.result;

          })
          .catch((error) => {
            console.log("fetchHistoricData error");
            this.error = error.response ? error.response.data.message : error.message;
            console.error('Erro fetchHistoricData ao buscar dados:', this.error);
          })
          .finally(() => {
            console.log('fetchHistoricData fim');
            this.loading = false;
          });

    },
    getVehicle(id) {
      this.hideModalDetallhes();
      let api = this.$store.state.api + 'vehicles/view/' + id;

      return axios
          .get(api)
          .then((response) => {
            const prevData = this.data || {};
            const prevDevices = prevData && Array.isArray(prevData.deviceAssignment) ? prevData.deviceAssignment : [];
            this.data = { ...response.data, deviceAssignment: prevDevices };
            this.processPositionVehicle();
            this.fetchActiveAssignmentDevices();
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    async getLastVehiclePosition(vehicleId) {
      if (!vehicleId) return;

      try {
        const api = `${this.$store.state.api}vehicle_last_updates/vehicle/${vehicleId}`;
        const {data: lastUpdate} = await axios.get(api);

        const coord = {
          lat: lastUpdate.lat ? parseFloat(lastUpdate.lat) : 0,
          lon: lastUpdate.long ? parseFloat(lastUpdate.long) : 0,
        };

        this.positionVehicle = {
          latitude: coord.lat,
          longitude: coord.lon,
          velocidade: lastUpdate.speed ?? 0,
          data: lastUpdate.updated_at ?? null,
        };

        this.centerMap = {
          lat: coord.lat,
          lng: coord.lon
        };

        this.postionDevice = {
          ...this.postionDevice,
          ...lastUpdate,
          coord: lastUpdate.coord || {lat: '0', lon: '0'}
        };

        this.selectedVehicleDetails = {
          BackBattery: lastUpdate.BackBattery ?? 0,
          CPRDateTime: lastUpdate.CPRDateTime ?? "",
          EDN2: lastUpdate.EDN2 ?? "",
          EDN3: lastUpdate.EDN3 ?? "",
          GSMStatus: lastUpdate.GSMStatus ?? "",
          IN1: lastUpdate.IN1 ?? "",
          IN2: lastUpdate.IN2 ?? "",
          IN3: lastUpdate.IN3 ?? "",
          Ignition: lastUpdate.Ignition ?? "",
          MainBattery: lastUpdate.MainBattery ?? 0,
          MainBatteryDec: lastUpdate.MainBatteryDec ?? 0,
          MsgDateTime: lastUpdate.MsgDateTime ?? "",
          Panic: lastUpdate.Panic ?? "",
          SleepMode: lastUpdate.SleepMode ?? "",
          VehicleBattery: lastUpdate.VehicleBattery ?? "",
          VehicleBatteryEvent: lastUpdate.VehicleBatteryEvent ?? "",
          altitude: lastUpdate.altitude ?? 0,
          angle: lastUpdate.angle ?? 0,
          batCharge: lastUpdate.batCharge ?? 0,
          cause: lastUpdate.cause ?? "",
          gps: lastUpdate.gps ?? "",
          imei: lastUpdate.imei ?? '',
          lat: coord.lat,
          lon: coord.lon,
          sats: lastUpdate.sats ?? 0,
          speed: lastUpdate.speed ?? 0,
          speed_limit: lastUpdate.speed_limit ?? "",
          speed_limit_100: lastUpdate.speed_limit_100 ?? "",
          speed_limit_60: lastUpdate.speed_limit_60 ?? "",
          speed_limit_80: lastUpdate.speed_limit_80 ?? "",
          timestamp: lastUpdate.timestamp ?? "",
          timestampGateway: lastUpdate.timestampGateway ?? ""
        };

        this.vehicleDatalhe = this.data;

      } catch (error) {
        console.error("Erro ao buscar posição do veículo:", error);
        this.$message('Sem posição informada', '', 'error');
      }
    },
    getVehicleData(id) {
      axios.get(`${this.$store.state.api}vehicles/view/${id}`)
          .then(response => {
            this.vehicle = response.data.vehicle;
            const prevDevices = this.data && Array.isArray(this.data.deviceAssignment) ? this.data.deviceAssignment : [];
            this.data = { ...response.data, deviceAssignment: prevDevices };
            this.processPositionVehicle();
          })
          .catch(error => {
            console.error('Erro ao buscar dados do veículo:', error);
          });
    },
    async onAssignmentChanged(payload = {}) {
      const id = this.$route.params.id;
      if (!id) return;

      const closeAllModals = () => {
        this.showAssignmentModal = false;
        this.showDeviceActivtions = false;
        this.showDeviceActivtionsConfigs = false;
        this.modalLicensingShow = false;
        this.modalAutoInsuranceShow = false;
        this.modalRefuleingShow = false;
        this.modalFineShow = false;
      };

      if (payload && payload.setVehicleInactive) {
        this.data = { ...this.data, level: 2 };
        if (payload.lastAssignment) {
          const a = payload.lastAssignment;
          this.data = {
            ...this.data,
            center_id: a.center_id || this.data.center_id,
            unit_id: a.unit_id || this.data.unit_id,
            center: a.center_name || this.data.center || this.data.center_name,
            unit: a.unit_name || this.data.unit || this.data.unit_name,
          };
        }

        this.activeAssignmentDevices = [];
        this.$set(this.data, 'deviceAssignment', []);

        if (!payload || payload.closeParent !== false) {
          closeAllModals();
        }

        return;
      }

      try {
        if (payload && payload.updatedVehicle && typeof payload.updatedVehicle === 'object') {
          this.data = { ...this.data, ...payload.updatedVehicle };
        } else if (payload && payload.lastAssignment && typeof payload.lastAssignment === 'object') {
          const a = payload.lastAssignment;
          this.data = {
            ...this.data,
            center_id: a.center_id || this.data.center_id,
            unit_id: a.unit_id || this.data.unit_id,
            center: a.center_name || this.data.center || this.data.center_name,
            unit: a.unit_name || this.data.unit || this.data.unit_name,
          };
        } else {
          await this.getVehicleData(id);
        }

        await this.fetchActiveAssignmentDevices();

        closeAllModals();
      } catch (e) {
        console.error('Erro ao atualizar atribuição:', e);
        window.location.reload();
      }
    },

    openChildTransfer() {
      if (this.$refs.vehicleAssignmentEditor && this.$refs.vehicleAssignmentEditor.openTransfer) {
        this.$refs.vehicleAssignmentEditor.openTransfer();
      }
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (!id) {
      console.warn('ID do veículo não informado');
      return;
    }

    this.getVehicleData(id);
    this.getLastVehiclePosition(id);
    this.fetchActiveAssignmentDevices();
  },
  components: {
    VehicleInfo,
    VehicleData,
  VehicleAssignmentEditor,
    DeviceActivation,
    Fines,
    Refueling,
    AutoInsurance,
    Licensing,
    MapPositionNowPoint,
    VehicleTrackingMap,
    DeviceConfig,
    Maintenances,
  },
}
</script>
